import { type FC } from "react";

import { type IAgGridCellProps } from "../../cell-base-interfaces.js";
import TableCellText from "./TableCellText.js";

const TableCellNumber: FC<IAgGridCellProps> = (props) => {
  if (props.data == null) {
    return null;
  }

  return <TableCellText style={{ textAlign: "right" }} {...props} />;
};

export default TableCellNumber;
